import produce from "immer";
import undoable, { groupByActionTypes } from 'redux-undo'
import { Element } from "../models/elementModel";
import { ADD_ELEMENT, ADD_ELEMENT_LIST, COPY_ELEMENT, COPY_TABLE_CELL_ELEMENTS, DROP_ELEMENT, EDIT_ELEMENT, ElementActionTypes, MOVE_ELEMENT, MOVE_ELEMENT_SECTION, REMOVE_ALL_ELEMENTS, REMOVE_ELEMENT, REMOVE_ELEMENT_BY_SECTION_ID, REMOVE_ELEMENT_LIST, REMOVE_ELEMENT_LIST_BY_FORM_ID, SET_ELEMENT } from "../types/actions";

const elementReducerDefaultState: Element[] = [];

const elementReducer = (state: Element[] = elementReducerDefaultState, action: ElementActionTypes): Element[] => {
    switch (action.type) {
        case ADD_ELEMENT:
            return produce(state, draft => { draft.push(action.element) });
        case ADD_ELEMENT_LIST:
            return produce(state, draft => { for (let index = 0; index < action.elements.length; index++) {
                draft.push(action.elements[index]);
            } });
        case REMOVE_ELEMENT:
            return produce(state, draft => { draft.splice(draft.findIndex(element => element.id === action.id), 1); });
        case REMOVE_ELEMENT_LIST_BY_FORM_ID:
                return produce(state, draft => { return draft.filter(element => element.formId !== action.formId) });
        case REMOVE_ELEMENT_LIST:
            return produce(state, draft => {
                for (let index = 0; index < action.elements.length; index++) {
                    draft.splice(draft.findIndex(element => element.id === action.elements[index].id), 1);
                }
            });
        case REMOVE_ELEMENT_BY_SECTION_ID:
            return produce(state, draft => { return draft.filter(element => element.sectionId !== action.id) });
        case SET_ELEMENT:
            return action.elements;
        case EDIT_ELEMENT:
            return produce(state, draft => { draft[draft.findIndex(element => element.id === action.element.id)] = action.element; });
        case COPY_ELEMENT:
            let copyIndex = state.indexOf(action.originalElement);
            return produce(state, draft => { draft.splice(copyIndex+1, 0, action.element); });
        case MOVE_ELEMENT:
            let dragIndex = state.indexOf(action.elementDrag);
            let hoverIndex = state.indexOf(action.elementDrop);
            return produce(state, draft => { draft.splice(dragIndex, 1); draft.splice(hoverIndex, 0, action.elementDrag); });
        case MOVE_ELEMENT_SECTION:
            let dragIndexElement = state.indexOf(action.elementDrag);
            let hoverIndexElement = state.indexOf(action.elementDrop);
            let newElement = produce(action.elementDrag, draft => { draft.sectionId = action.elementDrop.sectionId })
            return produce(state, draft => { draft.splice(dragIndexElement, 1); draft.splice(hoverIndexElement, 0, newElement); });
        case DROP_ELEMENT:
            return produce(state, draft => {
                const index = draft.findIndex(element => element.id === action.element.id);
                if (index !== -1) draft[index].sectionId = action.newSectionId;
            });
        case COPY_TABLE_CELL_ELEMENTS:
            return produce(state, draft => {
                draft = draft.concat(action.elements);
            });
        case REMOVE_ALL_ELEMENTS: 
            return produce(state, draft => { return draft = []});
        default:
            return state;
    }
}

const undoableElements = undoable(elementReducer, { groupBy: groupByActionTypes([EDIT_ELEMENT,MOVE_ELEMENT]) });

export default undoableElements
